import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { AddCustomerCompaniesRequest, AddCustomerCompaniesResponse, ChangeCustomerCompaniesRequest, ChangeCustomerCompaniesResponse } from "../../models/vessels/customer-company.models";
import { CustomerCompanyRoutes } from "../../constants/vessels/customer-companies.constants";

@autoinject
export class CustomerCompaniesService {

    constructor(private requestClient: RequestClientService) {
    }

    public addCustomerCompanies(addCustomerCompanyRequest: AddCustomerCompaniesRequest): Promise<AddCustomerCompaniesResponse> {
        return this.requestClient.post(`${CustomerCompanyRoutes.AddCustomerCompanies}`, {}, addCustomerCompanyRequest);
    }
    
    public changeCustomerCompanies(changeCustomerCompanyRequest: ChangeCustomerCompaniesRequest): Promise<ChangeCustomerCompaniesResponse> {
        return this.requestClient.post(`${CustomerCompanyRoutes.ChangeCustomerCompanies}`, {}, changeCustomerCompanyRequest);
    }
}